import { useEffect, useMemo, useState } from "react";
import { UseTablePaginationOutput, UseTablePaginationPropType } from "../types";

const defaultPageSizeOptions = [10, 20, 30, 50];

const useTablePagination = (props: UseTablePaginationPropType): UseTablePaginationOutput => {

    const { onPageChange, onPageSizeChange, totalRecords, pageSize = 10, pageSizeOptions, data = [], manual } = props;
    const [page, setPage] = useState(props.page ?? 1);
    const [internalizeSize, setPageSize] = useState<number>(pageSize);

    const paginationRowInfoStart = page == 1 ? 0 : ((page * internalizeSize) - internalizeSize);
    let paginationRowInfoEnd = page == 1 ? internalizeSize : page * internalizeSize;
    paginationRowInfoEnd = paginationRowInfoEnd > totalRecords ? totalRecords : paginationRowInfoEnd;

    useEffect(() => {
        setPage(props.page ?? page);
    }, [props.page])

    useEffect(() => {
        setPageSize(props.pageSize ?? internalizeSize);
    }, [props.pageSize])

    const memorizedData = useMemo(() => ({
        page,
        pageSize: internalizeSize,
        totalRecords,
        pageSizeOptions: pageSizeOptions ?? defaultPageSizeOptions,
        paginationRowInfoStart: (paginationRowInfoStart + 1),
        paginationRowInfoEnd,
    }), [page, internalizeSize, totalRecords]);

    let resultData = [...data as any[]];

    if (!manual) {
        resultData = resultData ? resultData.slice(paginationRowInfoStart, paginationRowInfoEnd) as any[] : []
    }

    const handlePageChange = (p: number) => {
        if (!manual) {
            setPage(p);
        }
        onPageChange && onPageChange(p);
    }

    const handlePageSizeChange = (ps: number) => {
        if (!manual) {
            setPageSize(ps);
            setPage(1);
        }
        onPageSizeChange && onPageSizeChange(ps);
    }

    return {
        ...memorizedData,
        showPagination: true,
        onPageChange: handlePageChange,
        onPageSizeChange: handlePageSizeChange,
        data: resultData
    };
}

export default useTablePagination;